module.exports = __webpack_public_path__ + "static/media/frameone.101a8fba.png";